export default {
    data() {
        return {
            alteredElements: [],
            addedClasses: [],
            addedClassZero : []
        };
    },
    methods: {
        elementClass(elementName, index){
            let classArray = [];

            if(this.addedClasses.length>0){
                classArray.push(this.addedClasses[index]);
            }

            return classArray;
        },
        addNeighbourClassHandle(payload) {
            const targetIndex = payload.refIndex+payload.offset;
            
            if(targetIndex<0){
                this.addedClassZero.push(payload.class);
                this.addedClasses[0].push('first-element-spacing');
            }else if (targetIndex>=this.addedClasses.length) {
                this.addedClasses[this.addedClasses.length-1].push('last-element-spacing');
            }else{
                this.addedClasses[targetIndex].push(payload.class);
            }
        }
    },
    created() {
        this.data.elements.forEach( (element, index) => {
            this.alteredElements.push(element);
            this.addedClasses.push([]);

            this.alteredElements[index].refIndex = index;
        } );
    }
}